var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4StairwayUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 21v4H54v11H40v12H26v12H10v-4h12V44h14V32h14V21h16zM13.93 37.9l16.49-16.5L35 25.76V14H23.24l4.35 4.58L11.1 35.07l2.83 2.83z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_Stairway_up.3a076ab3.svg";
export { SvgE4StairwayUp as ReactComponent };